import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { environment } from '../../environments/environment';
import { first, map, mergeMap } from 'rxjs';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.startsWith(environment.backendUrl)) {
        return next(req);
    }

    const authenticationService = inject(AuthenticationService);
    const token: string | undefined = authenticationService.getToken();

    if (token) {
        const authorization = environment.useMockAuthentication ? `Mock ${token}` : `Bearer ${token}`;

        req = req.clone({
            headers: req.headers.set('Authorization', authorization),
        });
    }

    if (req.url.includes('/tenant/v1')) {
        return next(req);
    }

    return authenticationService.selectedTenantId$.pipe(
        // only subscribe to a single tenant id.
        first(),
        map((tenant) => {

            req = req.clone({
                headers: req.headers.set('X-Tenant', tenant),
            });

            return req

        }),
        mergeMap((value, _) => next(value)),
    );
};
